import isPlainObject from 'isobject';
import assignStyle from 'css-in-js-utils/lib/assignStyle';

function resolveNamedKeys(style, keys) {
  for (var property in style) {
    var value = style[property];

    if (isPlainObject(value)) {
      var resolvedValue = resolveNamedKeys(value, keys);

      if (keys.hasOwnProperty(property)) {
        var resolvedKey = keys[property];
        if (style.hasOwnProperty(resolvedKey)) {
          style[resolvedKey] = assignStyle(style[resolvedKey], resolvedValue);
        } else {
          style[resolvedKey] = resolvedValue;
        }

        // We clean the old keys as they're not used anymore
        delete style[property];
      }
    }
  }

  return style;
}

export default function namedKeys(keys) {
  return function (style, type, renderer, props) {
    return resolveNamedKeys(style, keys instanceof Function ? keys(props) : keys);
  };
}